import React from 'react'
import {useTranslation} from "react-i18next";
import PrimaryButton from "../PrimaryButton";
import SecondaryButton from "../SecondaryButton";
import './hero.css';

const Hero = ({showCalModal}) => {
    const {t} = useTranslation();

    return (
        <div className="hero-container">
            <div className="hero-card">
                <div className="hero-profile-section">
                    <img alt="Louis Nguyen Profile" src="/profile_picture.jpg" className="hero-profile-image"/>
                    <div className="hero-name-section">
                        <span className="hero-greeting">{t("hero_hi-i-am")}</span>
                        <h1 className="hero-name">Louis Nguyen</h1>

                        <h2 className="hero-title">{t("hero_full-stack-developer")}</h2>
                        <h4 className="hero-subtitle">
                            <a href="mailto:business@louisnguyen.de" className="hero-mail-link"
                               aria-label="Email Louis Nguyen">
                                <svg className="hero-mail-icon" xmlns="http://www.w3.org/2000/svg" width="18"
                                     height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                     strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <rect x="3" y="5" width="18" height="14" rx="2" ry="2"/>
                                    <polyline points="22 6 12 13 2 6"/>
                                </svg>
                                business@louisnguyen.de
                            </a>
                        </h4>
                    </div>
                </div>
                <p className="hero-description">
                    {t("hero_description")}
                </p>

                <div className="hero-actions">
                    <PrimaryButton
                        button={t("hero_button-book-call")}
                        action={showCalModal}
                        size="lg"
                    />
                    <SecondaryButton
                        button={t("home_button-text-me")}
                        action={() => window.location.href = "mailto:business@louisnguyen.de"}
                        size="lg"
                        variant="outline"
                    />
                </div>
            </div>
        </div>
    );
}

export default Hero;
